
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },

        {
  hid: 'description',
  name: 'description',
  content: 'Enjoy exciting water sports in South Goa. From thrilling jet skiing to peaceful scuba diving, have a fun day on the water with family and friends.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Join the best water sports in South Goa. Experience jet skiing, parasailing, and more at beautiful beaches.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Get ready for fun with water sports in South Goa. Enjoy activities like jet skiing and scuba diving at stunning beaches.',
},




        {
          hid: 'keywords',
          name: 'keywords',
          content: 'water sports in south goa, water sports in south goa price, which beach is best for water sports in south goa, best water sports in south goa, water sports in south goa beaches, water sports in south goa beach, best beach for water sports in south goa, water sports in south goa palolem beach, water sports in colva beach',
        },
      
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
  {
    title: "Thrilling Activities",
    text: "Experience heart-pounding adventures with exciting water sports like jet skiing, parasailing, and scuba diving!",
  },
  {
    title: "Fun for All Ages",
    text: "Whether you're a seasoned adventurer or a first-timer, there's a water sport for everyone to enjoy!",
  },
  {
    title: "Safety First",
    text: "All activities are conducted with safety in mind, with trained instructors ensuring a secure experience.",
  },
  {
    title: "Convenient Booking",
    text: "Easily book your water sports package through the Goa App for hassle-free planning and great deals!",
  },
],


      title: 'Water Sports in South Goa - Water Sports in South Goa Price ',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-02T12%3A54%3A53.105Zpalolem-kayaling-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ELCCCgWPu8qNzQdQDIXd76sQQ2gGB5v4g%2B3c3PyZUHLp5xN7AcC3yyn9r3mPbXpNcFzRTQCw77o3D4KDepI%2F5bMCOIOCaZO%2BPheeR2ahFkH7Oek6qNDbLVmuVdsOrzqIEHk%2BhrqkfRbGM57y0Djn2Sm6koGbqWvQqChBD6Pn3bYk5i8TCF14aVqoZQX9%2BGykODLfaCDJ2znWr1MhRgeli3%2BXk2SJH%2FtcQ45KqqwRyYGJf0jvBqe8wiUJLh90VDRkR53wnhraKQpaqKvrt3w3jRdoVfMggzy5fhk8HSzE698KdNSEvbUIdIQzvXGFh2A5Ej5MVScMSX5jysluDZfo6g%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-02T12%3A54%3A53.105Zpalolem-kayaling-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ELCCCgWPu8qNzQdQDIXd76sQQ2gGB5v4g%2B3c3PyZUHLp5xN7AcC3yyn9r3mPbXpNcFzRTQCw77o3D4KDepI%2F5bMCOIOCaZO%2BPheeR2ahFkH7Oek6qNDbLVmuVdsOrzqIEHk%2BhrqkfRbGM57y0Djn2Sm6koGbqWvQqChBD6Pn3bYk5i8TCF14aVqoZQX9%2BGykODLfaCDJ2znWr1MhRgeli3%2BXk2SJH%2FtcQ45KqqwRyYGJf0jvBqe8wiUJLh90VDRkR53wnhraKQpaqKvrt3w3jRdoVfMggzy5fhk8HSzE698KdNSEvbUIdIQzvXGFh2A5Ej5MVScMSX5jysluDZfo6g%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-02T12%3A54%3A53.105Zpalolem-kayaling-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ELCCCgWPu8qNzQdQDIXd76sQQ2gGB5v4g%2B3c3PyZUHLp5xN7AcC3yyn9r3mPbXpNcFzRTQCw77o3D4KDepI%2F5bMCOIOCaZO%2BPheeR2ahFkH7Oek6qNDbLVmuVdsOrzqIEHk%2BhrqkfRbGM57y0Djn2Sm6koGbqWvQqChBD6Pn3bYk5i8TCF14aVqoZQX9%2BGykODLfaCDJ2znWr1MhRgeli3%2BXk2SJH%2FtcQ45KqqwRyYGJf0jvBqe8wiUJLh90VDRkR53wnhraKQpaqKvrt3w3jRdoVfMggzy5fhk8HSzE698KdNSEvbUIdIQzvXGFh2A5Ej5MVScMSX5jysluDZfo6g%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/watersports/water-sports-in-south-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/watersports/water-sports-in-south-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-02T12%3A54%3A53.105Zpalolem-kayaling-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ELCCCgWPu8qNzQdQDIXd76sQQ2gGB5v4g%2B3c3PyZUHLp5xN7AcC3yyn9r3mPbXpNcFzRTQCw77o3D4KDepI%2F5bMCOIOCaZO%2BPheeR2ahFkH7Oek6qNDbLVmuVdsOrzqIEHk%2BhrqkfRbGM57y0Djn2Sm6koGbqWvQqChBD6Pn3bYk5i8TCF14aVqoZQX9%2BGykODLfaCDJ2znWr1MhRgeli3%2BXk2SJH%2FtcQ45KqqwRyYGJf0jvBqe8wiUJLh90VDRkR53wnhraKQpaqKvrt3w3jRdoVfMggzy5fhk8HSzE698KdNSEvbUIdIQzvXGFh2A5Ej5MVScMSX5jysluDZfo6g%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-02T12%3A54%3A53.105Zpalolem-kayaling-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ELCCCgWPu8qNzQdQDIXd76sQQ2gGB5v4g%2B3c3PyZUHLp5xN7AcC3yyn9r3mPbXpNcFzRTQCw77o3D4KDepI%2F5bMCOIOCaZO%2BPheeR2ahFkH7Oek6qNDbLVmuVdsOrzqIEHk%2BhrqkfRbGM57y0Djn2Sm6koGbqWvQqChBD6Pn3bYk5i8TCF14aVqoZQX9%2BGykODLfaCDJ2znWr1MhRgeli3%2BXk2SJH%2FtcQ45KqqwRyYGJf0jvBqe8wiUJLh90VDRkR53wnhraKQpaqKvrt3w3jRdoVfMggzy5fhk8HSzE698KdNSEvbUIdIQzvXGFh2A5Ej5MVScMSX5jysluDZfo6g%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/watersports/water-sports-in-south-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Water Sports in South Goa",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Water Sports in South Goa - Book @ ₹1499 Flat 40% Off",
  "description": "Enjoy the ultimate Water Sports in South Goa with jet skiing, parasailing, banana boat, bumper, and speed boat rides for an action-packed experience!",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-02T12%3A54%3A53.105Zpalolem-kayaling-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ELCCCgWPu8qNzQdQDIXd76sQQ2gGB5v4g%2B3c3PyZUHLp5xN7AcC3yyn9r3mPbXpNcFzRTQCw77o3D4KDepI%2F5bMCOIOCaZO%2BPheeR2ahFkH7Oek6qNDbLVmuVdsOrzqIEHk%2BhrqkfRbGM57y0Djn2Sm6koGbqWvQqChBD6Pn3bYk5i8TCF14aVqoZQX9%2BGykODLfaCDJ2znWr1MhRgeli3%2BXk2SJH%2FtcQ45KqqwRyYGJf0jvBqe8wiUJLh90VDRkR53wnhraKQpaqKvrt3w3jRdoVfMggzy5fhk8HSzE698KdNSEvbUIdIQzvXGFh2A5Ej5MVScMSX5jysluDZfo6g%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "1499",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/watersports/water-sports-in-south-goa",
        "url": "https://www.goa.app/watersports/water-sports-in-south-goa",
        "name": "Water Sports in South Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-02T12%3A54%3A53.105Zpalolem-kayaling-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ELCCCgWPu8qNzQdQDIXd76sQQ2gGB5v4g%2B3c3PyZUHLp5xN7AcC3yyn9r3mPbXpNcFzRTQCw77o3D4KDepI%2F5bMCOIOCaZO%2BPheeR2ahFkH7Oek6qNDbLVmuVdsOrzqIEHk%2BhrqkfRbGM57y0Djn2Sm6koGbqWvQqChBD6Pn3bYk5i8TCF14aVqoZQX9%2BGykODLfaCDJ2znWr1MhRgeli3%2BXk2SJH%2FtcQ45KqqwRyYGJf0jvBqe8wiUJLh90VDRkR53wnhraKQpaqKvrt3w3jRdoVfMggzy5fhk8HSzE698KdNSEvbUIdIQzvXGFh2A5Ej5MVScMSX5jysluDZfo6g%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-02T12%3A54%3A53.105Zpalolem-kayaling-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ELCCCgWPu8qNzQdQDIXd76sQQ2gGB5v4g%2B3c3PyZUHLp5xN7AcC3yyn9r3mPbXpNcFzRTQCw77o3D4KDepI%2F5bMCOIOCaZO%2BPheeR2ahFkH7Oek6qNDbLVmuVdsOrzqIEHk%2BhrqkfRbGM57y0Djn2Sm6koGbqWvQqChBD6Pn3bYk5i8TCF14aVqoZQX9%2BGykODLfaCDJ2znWr1MhRgeli3%2BXk2SJH%2FtcQ45KqqwRyYGJf0jvBqe8wiUJLh90VDRkR53wnhraKQpaqKvrt3w3jRdoVfMggzy5fhk8HSzE698KdNSEvbUIdIQzvXGFh2A5Ej5MVScMSX5jysluDZfo6g%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-02T12%3A54%3A53.105Zpalolem-kayaling-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ELCCCgWPu8qNzQdQDIXd76sQQ2gGB5v4g%2B3c3PyZUHLp5xN7AcC3yyn9r3mPbXpNcFzRTQCw77o3D4KDepI%2F5bMCOIOCaZO%2BPheeR2ahFkH7Oek6qNDbLVmuVdsOrzqIEHk%2BhrqkfRbGM57y0Djn2Sm6koGbqWvQqChBD6Pn3bYk5i8TCF14aVqoZQX9%2BGykODLfaCDJ2znWr1MhRgeli3%2BXk2SJH%2FtcQ45KqqwRyYGJf0jvBqe8wiUJLh90VDRkR53wnhraKQpaqKvrt3w3jRdoVfMggzy5fhk8HSzE698KdNSEvbUIdIQzvXGFh2A5Ej5MVScMSX5jysluDZfo6g%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "The Water Sports in South Goa offers an exciting mix of jet skiing, parasailing, banana boat rides, bumper rides, and speed boat experiences. Perfect for adventure lovers, this package promises thrills and unforgettable memories on Goa’s beautiful waters.",
        "breadcrumb": {
            "@id": "https://www.goa.app/watersports/water-sports-in-south-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/watersports/water-sports-in-south-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
      "@type": "Question",
      "name": "What water sports are available in South Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "In South Goa, you can enjoy a variety of water sports, including jet skiing, parasailing, scuba diving, kayaking, and banana boat rides."
      }
    },
    {
      "@type": "Question",
      "name": "What is the cost of water sports in South Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Prices for water sports in South Goa typically start from ₹899 for basic activities and can go up to ₹3,499 for premium packages that include scuba diving."
      }
    },
    {
      "@type": "Question",
      "name": "Is scuba diving available in South Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, many water sports packages in South Goa offer scuba diving, with options suitable for both beginners and experienced divers."
      }
    },
    {
      "@type": "Question",
      "name": "Do I need prior experience for water sports in South Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most water sports in South Goa are beginner-friendly, with professional instructors available to guide you, especially for activities like scuba diving and jet skiing."
      }
    },
    {
      "@type": "Question",
      "name": "What is the best time for water sports in South Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The best time for water sports in South Goa is from November to April when the weather is pleasant and the sea conditions are ideal."
      }
    },
    {
      "@type": "Question",
      "name": "Are safety measures provided during water sports?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all water sports operators in South Goa prioritize safety and provide essential safety gear, including life jackets and helmets, for participants."
      }
    },
    {
      "@type": "Question",
      "name": "Can I book water sports activities online in South Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely! You can conveniently book water sports activities online through various platforms, including the Goa App, which often has special deals and offers."
      }
    },
    {
      "@type": "Question",
      "name": "What should I wear for water sports in South Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It's advisable to wear a swimsuit, comfortable clothing, and flip-flops for water sports. Don't forget to apply sunscreen to protect your skin from the sun."
      }
    },
    {
      "@type": "Question",
      "name": "Are meals included in water sports packages in South Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Some water sports packages in South Goa may include meals, while others might only offer refreshments. Be sure to check the package details before booking."
      }
    },
    {
      "@type": "Question",
      "name": "How do I find the best water sports package in South Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "To find the best water sports package in South Goa, compare options online, read reviews, and look for promotions on platforms like the Goa App for discounts."
      }
    }
        ]
      }
    ]
  };
},


};



  